import store_produit from '@/store/mods/stock/produits'
import $ from 'jquery'

export default {
    name: 'l-medicament',
    components: {},
    props: [],
    data() {
        return {
            is_loading: true,
            is_empty: false,
            categories_medicaments: [],
            is_load_error: false,
            all_checked: false,
            one_is_checked: [],
			each_cat_is_checked: [],
        }
    },

    computed: {

    },

    mounted() {
        this.fetchCategoriesMedicaments()
    },

    methods: {
        fetchCategoriesMedicaments() {
            this.is_loading = true;
            this.is_load_error = false;

            store_produit.getListeMedicamentsParCategorie().then((response) => {
               this.categories_medicaments = response

                if (this.categories_medicaments.length === 0) {
                    this.is_empty = true;
                } else {
                    this.is_empty = false;
                }
                console.log("stop loading");
                

                this.is_loading = false;
                console.log("loading ", this.is_loading);
            }).catch(() => {
                this.is_loading = false;
                this.is_load_error = true
            });
        },

        toutSelectionner() {
            let is_checked = $('#medoc-tous').is(":checked")

			this.toggleAllChecked(is_checked)
        },

        toggleAllChecked(is_checked) {
            this.one_is_checked = []
            this.each_cat_is_checked = []
            
            this.categories_medicaments.forEach((categorie_medicament) => {
                if (is_checked) {
                    this.each_cat_is_checked.push(categorie_medicament.categorie_id)
                }

                categorie_medicament.medicaments.forEach((medicament) => {
                    if (is_checked) {
                        this.one_is_checked.push({id: medicament.medicament_id, libelle: medicament.medicament})
                    }
                })
            });
            
            this.all_checked = is_checked
        },

		/**
		 * Sélectionner / Déselectionner une catégorie de médicament
		 */
		touteCategorie(index) {
			let is_checked = $('#catmed-tous'+index).is(":checked")
			this.toggleCategorieChecked(is_checked, index)
		},

		toggleCategorieChecked(is_checked, index) {
            this.categories_medicaments.forEach((categorie_medicament) => {
                if (categorie_medicament.categorie_id == index) {
                    if (is_checked) {
                        // remove all medicaments of this category from one_is_checked
                        this.one_is_checked = this.one_is_checked.filter((medicament) => {
                            return !categorie_medicament.medicaments.some((m) => m.medicament_id === medicament.id)
                        })
                    }

                    categorie_medicament.medicaments.forEach((medicament) => {
                        if (is_checked) {
                            this.one_is_checked.push({id: medicament.medicament_id, libelle: medicament.medicament})
                        } else {
                            this.one_is_checked = this.one_is_checked.filter((medicament) => {
                                return !categorie_medicament.medicaments.some((m) => m.medicament_id === medicament.id)
                            })
                        }
                    })
                }
            });
            
            this.all_checked = is_checked
        },
    }
}